import Cookie from "universal-cookie";
import { isNative } from "@/lib/platform";

const EXPIRE_TIME = 1000 * 60 * 5
const FIBA_CACHE = "ME_CORE_CACHE"
const cookie = new Cookie();

const currentTime = () => {
    return Date.now()
}

/**
 * ⚠ Native (Capacitor) дээр cookie АЖИЛЛАДАГГҮЙ.
 *
 * iOS дээр апп нь `capacitor://localhost` гэсэн http(s) БИШ схемээс ачаалагддаг
 * бөгөөд WKWebView нь ийм схем дээр `document.cookie`-г хадгалдаггүй. Үүнээс болж
 * нэвтэрсний дараа токен (TOKEN_NAME) алга болж, дараагийн API дуудлага 401 авч
 * `window.location = '/login'` ажиллан login дэлгэц рүү буцдаг байв.
 *
 * Иймд native дээр Web Storage-оор дэмжинэ (энэ нь бүх схем дээр ажилладаг).
 *
 * ⚠ ЯАГААД localStorage БИШ sessionStorage вэ:
 * Цэс/эрх (APP_MENU, APP_PERMS) нь sessionStorage-д хадгалагддаг. Хэрэв токеныг
 * localStorage-д байнгын хадгалбал апп дахин нээхэд "токен байгаа ч цэс байхгүй"
 * зөрчилтэй төлөв үүсч, getMenu()-ийн JSON.parse("") уначихна. sessionStorage нь
 * цэстэй ижил амьдралын мөчлөгтэй тул вэбийн зан төлөвтэй ЯГ адилхан болно
 * (хөтөч хаахад нэвтрэлт дуусдагтай ижил).
 * Апп хаасны дараа ч нэвтэрсэн хэвээр байлгах бол цэс/эрхийг мөн хамт байнгын
 * хадгалалт руу шилжүүлэх ёстой — тусдаа ажил.
 *
 * Вэб дээр зан төлөв ӨӨРЧЛӨГДӨХГҮЙ — cookie хэвээр ажиллана.
 */
const NATIVE_PREFIX = "melp.";

export function GetCookie(key) {
    if (isNative()) {
        const v = sessionStorage.getItem(NATIVE_PREFIX + key);
        return v === null ? "" : v;
    }
    return cookie.get(key) ?? "";
}
export function SetCookie(key, value, options = null) {
    if (isNative()) {
        // `options` (path/expiry) нь Web Storage-д хамаарахгүй. Одоогийн бүх дуудлага
        // default-оор дууддаг тул алдагдах зүйлгүй.
        sessionStorage.setItem(NATIVE_PREFIX + key, String(value));
        return;
    }
    cookie.set(key, value, options || { path: '/' });
}
export function RemoveCookie(key) {
    if (isNative()) {
        sessionStorage.removeItem(NATIVE_PREFIX + key);
        return;
    }
    cookie.remove(key);
}

export function GetTimeCookie(key) {
    const data = getFibaCache()
    if (data && data[key]) {
        if (data[key].expiry <= currentTime()) {
            delete data[key]
            return null
        } else {
            return data[key].data
        }
    } else {
        return null
    }
}

export function SetTimeCookie(key, value, time) {
    const item = {
        expiry: new Date().getTime() + (time ?? EXPIRE_TIME),
        data: value
    }
    const data = getFibaCache()
    data[key] = item
    localStorage.setItem(FIBA_CACHE, JSON.stringify(data));
}

const getFibaCache = () => {

    let fibaCache = {
        data: {},
        nextCleanup: new Date().getTime() + EXPIRE_TIME
    }

    try {
        const data = localStorage.getItem(FIBA_CACHE)
        if (data) {
            fibaCache = JSON.parse(data)
        }
    }
    catch (e) {
        console.error(e.message)
    }

    return fibaCache
}
